var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224,
    height: 169,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M111.674 168.066c61.675 0 111.673-2.338 111.673-5.222 0-2.884-49.998-5.222-111.673-5.222C49.998 157.622 0 159.96 0 162.844c0 2.884 49.998 5.222 111.674 5.222Z",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M111.673 160.078c50.084 0 90.692 1.239 90.692 2.766s-40.608 2.766-90.692 2.766c-50.083 0-90.691-1.239-90.691-2.766s40.608-2.766 90.691-2.766Z",
    opacity: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M143.937 159.583c30.611 0 55.426-1.238 55.426-2.766 0-1.527-24.815-2.765-55.426-2.765-30.61 0-55.425 1.238-55.425 2.765 0 1.528 24.815 2.766 55.425 2.766Z",
    opacity: 0.35
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#303A7D",
    d: "M100.381 12.91h66.44c4.69 0 8.526 3.705 8.526 8.235v128.366c0 4.53-3.836 8.235-8.526 8.235h-66.44c-4.69 0-8.525-3.705-8.525-8.235V21.135c0-4.52 3.835-8.225 8.525-8.225Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M103.169 16.49h60.874c4.295 0 7.81 3.396 7.81 7.544v122.567c0 4.148-3.515 7.543-7.81 7.543h-60.874c-4.294 0-7.81-3.395-7.81-7.543V24.034c0-4.148 3.516-7.543 7.81-7.543Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M133.607 40.649c4.946 0 8.963 3.87 8.963 8.658 0 4.778-4.006 8.658-8.963 8.658-4.946 0-8.963-3.87-8.963-8.658 0-4.788 4.017-8.658 8.963-8.658Zm0 2.24c-3.664 0-6.634 2.868-6.634 6.408 0 3.54 2.97 6.408 6.634 6.408s6.634-2.869 6.634-6.408c0-3.54-2.97-6.409-6.634-6.409ZM126.021 60.566h15.16c.363 0 .652.33.652.733v1.269c0 .402-.289.733-.652.733h-15.16c-.363 0-.651-.33-.651-.733v-1.27c0-.402.299-.732.651-.732Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M119.579 66.19h28.054c.417 0 .759.33.759.733v1.27c0 .402-.342.732-.759.732h-28.054c-.417 0-.759-.33-.759-.733v-1.27c0-.402.342-.732.759-.732Z",
    opacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M106.61 12.91v19.163c0 1.208-1.026 2.188-2.265 2.188H91.856V21.134c0-4.53 3.835-8.235 8.525-8.235h6.229v.01Z",
    opacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M73.032 1.538h28.46c1.143 0 2.073.897 2.073 2.002v25.912c0 1.104-.93 2.002-2.073 2.002h-28.46c-1.144 0-2.073-.898-2.073-2.002V3.54c0-1.105.93-2.002 2.073-2.002Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF84D6",
    d: "M75.403 3.54c1.592 0 2.895 1.248 2.895 2.796 0 1.538-1.293 2.797-2.895 2.797-1.592 0-2.895-1.249-2.895-2.797S73.81 3.54 75.403 3.54Z",
    opacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M75.403 4.83c.855 0 1.56.67 1.56 1.506 0 .826-.694 1.507-1.56 1.507-.854 0-1.56-.671-1.56-1.507 0-.836.706-1.507 1.56-1.507Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF84D6",
    d: "M80.029 4.2h8.3c.3 0 .535.237.535.516v.537a.527.527 0 0 1-.534.516h-8.301a.527.527 0 0 1-.534-.516v-.537c0-.279.245-.516.534-.516ZM80.029 6.883h15.02c.3 0 .535.237.535.516v.537a.527.527 0 0 1-.534.516H80.029a.527.527 0 0 1-.534-.516v-.537c0-.279.245-.516.534-.516Z",
    opacity: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M74.495 10.65h25.533c1.026 0 1.859.805 1.859 1.795v15.676c0 .99-.833 1.795-1.859 1.795H74.495c-1.026 0-1.859-.805-1.859-1.795V12.445c0-.99.834-1.795 1.86-1.795Z",
    opacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "m81.001 13.24 8.366 10.805 5.181-4.293 6.164 8.947h-26.9l7.19-15.459Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC770",
    d: "M90.339 13.24c1.025 0 1.848.805 1.848 1.785 0 .991-.834 1.786-1.848 1.786-1.026 0-1.849-.805-1.849-1.786-.01-.98.823-1.785 1.849-1.785Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "m159.396 34.25-28.781-.113c-.908 0-1.741-.732-1.848-1.62l-.609-4.799-1.859-14.695 29.593.124 11.079-.258 2.318.361-4.23 17.668c-.47 2.672-1.058 3.354-5.663 3.333Z",
    opacity: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#E23B93",
    d: "M139.354 5.8h27.297c.94 0 1.527.743 1.324 1.64l-5.106 21.981c-.214.908-1.144 1.641-2.084 1.641h-27.296c-.94 0-1.527-.743-1.314-1.64l5.107-21.982c.203-.897 1.143-1.64 2.072-1.64Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4FF",
    d: "M134.878 0h26.163c1.603 0 2.906 1.259 2.906 2.807v24.808c0 1.548-1.303 2.807-2.906 2.807h-26.153c-1.602 0-2.906-1.259-2.906-2.807V2.807C131.972 1.269 133.286 0 134.878 0Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCE8F8",
    d: "M134.547 2.683h26.826c.406 0 .737.32.737.712v1.58a.726.726 0 0 1-.737.711h-26.826a.726.726 0 0 1-.737-.712V3.395c0-.392.331-.712.737-.712ZM134.311 9.102h27.307c.267 0 .491.217.491.475v1.062a.489.489 0 0 1-.491.475h-27.307a.489.489 0 0 1-.491-.475V9.577c-.011-.258.213-.475.491-.475ZM134.311 14.282h27.307c.267 0 .491.217.491.475v1.063a.489.489 0 0 1-.491.475h-27.307a.489.489 0 0 1-.491-.475v-1.063c-.011-.268.213-.475.491-.475ZM134.311 19.463h27.307c.267 0 .491.217.491.475V21a.489.489 0 0 1-.491.474h-27.307a.489.489 0 0 1-.491-.475v-1.062c-.011-.269.213-.475.491-.475Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M149.321 8.41h8.718c.844 0 1.613.66 1.72 1.476l2.532 19.71c.107.816-.492 1.476-1.336 1.476h-27.648c-.844 0-1.613-.66-1.72-1.475l-.566-4.366-1.977-15.335-.352-2.714c-.161-1.269.78-2.3 2.083-2.3h11.517c1.314 0 1.965.463 2.82 1.516 1.485 1.806 1.784 2.012 4.209 2.012Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M145.561 85.849v17.027c0 4.118-3.28 7.492-7.275 7.492H92.358V78.357h45.928c4.006 0 7.275 3.364 7.275 7.492Z",
    opacity: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M141.278 84.951v14.995c0 3.622-3.077 6.594-6.827 6.594H82.583c-3.75 0-6.827-2.962-6.827-6.594V84.95c0-3.622 3.067-6.594 6.827-6.594h51.879c3.75 0 6.816 2.962 6.816 6.594Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M98.288 87.51h39.453c.599 0 1.09.516 1.09 1.146v2.549c0 .63-.491 1.145-1.09 1.145H98.288c-.599 0-1.09-.516-1.09-1.145v-2.549c-.01-.63.48-1.146 1.09-1.146ZM97.839 94.734h32.969c.353 0 .641.279.641.62v1.393c0 .34-.288.619-.641.619H97.839a.632.632 0 0 1-.641-.62v-1.392c-.01-.33.278-.62.641-.62ZM86.803 85.601c3.91 0 7.083 3.065 7.083 6.842 0 3.777-3.173 6.842-7.083 6.842s-7.083-3.065-7.083-6.842c0-3.777 3.162-6.842 7.083-6.842Z",
    opacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M86.803 88.078c2.489 0 4.519 1.95 4.519 4.365 0 2.405-2.02 4.365-4.52 4.365-2.489 0-4.518-1.95-4.518-4.365 0-2.404 2.019-4.365 4.519-4.365Zm0 1.734c-1.507 0-2.724 1.176-2.724 2.631 0 1.455 1.217 2.632 2.724 2.632 1.506 0 2.724-1.177 2.724-2.632s-1.218-2.631-2.724-2.631ZM75.313 119.711c5.818-.042 10.499-4.631 10.455-10.251-.043-5.62-4.794-10.141-10.612-10.1-5.818.043-10.499 4.632-10.455 10.252.043 5.62 4.794 10.141 10.612 10.099Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M75.233 105.879a5.72 5.72 0 0 1 2.553.599v-1.538a.374.374 0 0 0-.106-.247.36.36 0 0 0-.257-.103h-4.39a.401.401 0 0 0-.257.103.335.335 0 0 0-.107.247v1.538a5.8 5.8 0 0 1 2.564-.599Zm4.765 2.601c.502.805.79 1.754.79 2.766 0 2.961-2.489 5.366-5.555 5.366s-5.555-2.405-5.555-5.366c0-1.012.288-1.961.79-2.766v-3.54c0-.681.289-1.3.759-1.754a2.632 2.632 0 0 1 1.816-.733h4.39c.706 0 1.347.279 1.817.733.46.444.759 1.073.759 1.754v3.54h-.011Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#21389B",
    d: "M75.233 110.069c.62 0 1.122.485 1.122 1.084 0 .34-.171.65-.428.846v1.981c0 .372-.31.671-.694.671a.681.681 0 0 1-.694-.671v-1.991a1.074 1.074 0 0 1-.428-.846c0-.589.502-1.074 1.122-1.074Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M91.856 122.556h10.053c2.628 0 4.839 1.775 5.416 4.138h5.342c4.54 0 8.247 3.581 8.247 7.967v22.538H97.389c-3.215-1.176-5.523-4.19-5.523-7.709v-26.934h-.01Z",
    opacity: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#E23B93",
    d: "M79.41 162.06h33.257c2.692 0 4.904-2.126 4.904-4.737v-22.662c0-2.6-2.201-4.736-4.904-4.736H79.409c-2.692 0-4.903 2.125-4.903 4.736v22.662c0 2.601 2.211 4.737 4.903 4.737Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#E23B93",
    d: "M79.41 131.999h33.257c2.692 0 4.904 2.126 4.904 4.716v8.039l-12.778 6.78h-4.786v.908c0 .66-.534 1.207-1.175 1.207h-5.203c-.64 0-1.175-.536-1.175-1.207v-.908h-5.16l-12.788-6.78v-8.039c0-2.59 2.211-4.716 4.903-4.716Z",
    opacity: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M90.168 125.786h11.741c1.218 0 2.222.96 2.222 2.147v3.653c-8.215 4.376-7.97 4.376-16.185 0v-3.653c.01-1.177 1.004-2.147 2.222-2.147Zm1.741 2.075c-.94 0-1.709.691-1.709 1.548v2.641c6.282 3.148 5.384 3.148 11.666 0v-2.641c0-.847-.769-1.548-1.709-1.548h-8.248Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#E23B93",
    d: "M104.131 128.758v2.828c-8.215 4.375-7.97 4.375-16.185 0v-2.828h2.414c-.107.196-.16.423-.16.65v2.642c6.282 3.148 5.384 3.148 11.666 0v-2.642c0-.237-.053-.454-.16-.65h2.425Z",
    opacity: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M79.41 129.935h33.257c2.692 0 4.903 2.126 4.903 4.737v8.07l-12.777 6.81h-17.5l-12.777-6.81v-8.081c-.01-2.6 2.2-4.726 4.893-4.726Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M94.238 146.88H98.2c.492 0 .898.392.898.866v3.519c0 .475-.406.867-.898.867h-3.963c-.492 0-.898-.392-.898-.867v-3.519c0-.474.406-.866.898-.866Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD85E",
    d: "M94.409 147.096h3.643c.448 0 .822.362.822.795v3.23c-.833-2.559-1.955-3.137-4.465-4.025Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M77.892 51.836c.16-2.023.802-2.157 3.537-3.85.566-.35 1.11-.825 2.371-2.228.876.701.225 1.444-.374 2.466-.288.506-.598 1.187-.715 1.713 2.457-.145 3.29-.588 3.867-1.207 2.874-3.096 3.397-3.674 7.18-3.653-1.774 2.218-3.099 3.642-4.018 5.974-.566 1.435-.448 1.321-1.474 1.776-1.389.608-2.564 1.248-3.868 1.867-2.905 1.373-2.83 2.075-4.721 4.654l-3.6-1.98c1.238-2.622 1.591-2.643 1.815-5.532Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8978",
    d: "M79.506 53.94c1.389-3.167 2.553-3.374 6.656-4.509l2.264 1.321-1.933-.702c-2.82 1.3-5.545 1.136-6.987 3.89Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M49.55 50.298c8.226 2.57 10.768 13.89 15.116 13.705 3.825-.155 7.287-3.23 12.233-10.103 1.26-.052 3.59 1.496 4.604 3.426-3.493 5.903-8.482 16.666-16.367 16.914-4.08.134-10.405-3.014-14.198-7.781-6.442-8.101-4.508-7.967-1.389-16.16Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#6266D7",
    d: "M50.96 58.069c5.17 9.07 9.54 12.89 13.824 13.653 2.233.402 6.474-1.166 11.934-6.275-2.981 4.52-6.73 8.628-11.56 8.782-4.08.135-10.405-3.013-14.198-7.78v-8.38Z",
    opacity: 0.35
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F2F64",
    d: "M15.865 162.339c1.901 1.609 2.542 2.28 5 2.373 2.008.083 2.681-.423 3.835-1.31 1.271-.991 1.677-1.61 1.666-2.508-.01-1.713-.908-3.271-1.004-5.418l-4.027.175-1.742-.784c-.78.991-2.436 2.807-3.59 4.417-.566.784-.384 2.208-.138 3.055Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M25.768 157.86c-.192-.733-.363-1.507-.406-2.384l-4.027.175-1.742-.784c-.31.392-.748.908-1.239 1.486 1.581 1.62 6.389 2.529 7.414 1.507Z",
    opacity: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F2F64",
    d: "M46.793 154.021c-.331 1.579-1.325 2.796-1.485 3.952-.267 2.002.93 4.015 3.376 4.035l16.057.134c-.854-5.294-9.433-2.363-12.318-8.235l-3.739.207-1.89-.093Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M46.793 154.021c-.107.516-.288.991-.48 1.445 1.506 1.011 4.401 1.692 7.766.578a6.431 6.431 0 0 1-1.656-2.116l-3.739.206-1.89-.113Z",
    opacity: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M57.786 86.406c.651 3.798.865 7.42.812 12.147-.203 17.76-3.163 37.873-5.128 55.612-2.618.97-5.502.919-7.682.052-.32-10.278-.427-20.866-.983-31.011-.694-12.786-2.36-22.785-5.384-38.74l12.425-.402 5.94 2.343Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E2353",
    d: "M49.891 86.406c.652 3.798.663 14.747.61 19.474-.182 15.84-2.693 32.672-4.712 48.347-.32-10.278-.428-20.866-.983-31.01-.61-11.197-1.966-20.258-4.316-33.054l9.401-3.757Z",
    opacity: 0.3
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M33.214 87.738c-.983 2.869-2.275 5.046-3.632 10.918-1.474 6.388-1.891 12.404-2.991 18.617-2.17 12.167-4.872 24.488-8.643 37.666 2.18 1.755 6.442 1.755 8.002 1.218 4.658-10.227 7.51-20.195 11.613-30.567 5.608-14.199 11.74-28.43 16.601-41.928l-20.95 4.076Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M32.274 64.147c-.075 7.709.406 18.266-.053 25.81 8.685 1.795 18.001 2.456 26.398-.31-.107-5.005-1.314-12.466-2.553-19.37-.844-4.737.085-9.215-.908-13.405-.876-3.695-3.002-5.965-6.08-6.822-2.2-.619-4.625-.877-7.082-.784-5.385.207-11.496 1.651-15.342 6.171-4.882 5.202.92 13.034 5.62 8.71Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M38.332 45.654c-.086 1.59-.182 2.828-.47 4.396.716 2.415 3.045 4.004 5.374 3.705 1.997-.258 2.52-2.869 1.837-4.489a22.312 22.312 0 0 1-.16-2.24l-5.064-1.424-1.517.052Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M38.332 45.654a121.25 121.25 0 0 1-.15 2.208c1.464 2.962 5.567 3.592 6.977 2.137-.096-.785-.224-2.188-.246-2.983l-5.064-1.413-1.517.051Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M37.541 43.766c-1.292.237-1.624-.186-1.933-1.022-.31-.867-.289-.63-.834-1.29a3.186 3.186 0 0 1-.566-.95c-.417-1.062-.182-1.702-.192-2.528-.022-1.01-.481-1.403-.663-2.053-.908-3.179 1.923-5.955 5.01-4.49 1.112-1.94 2.885-1.97 4.499-1.083 1.88-1.104 3.685-.98 4.967.434 2.479 2.745.16 5.48-1.549 6.212l-5.427 3.725-3.312 3.045Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#22043D",
    d: "M37.541 43.766c-1.293.237-1.624-.186-1.934-1.022-.31-.867-.288-.63-.833-1.29a3.185 3.185 0 0 1-.566-.95c-.417-1.062-.182-1.702-.192-2.527v-.031c.8 1.341 2.52 1.6 2.681-.28.855-.65 1.4-1.454 1.517-2.393.15-1.187.673-1.847 2.051-1.476 3.195.877 5.812 2.487 8.622-.082-.203 1.558-1.528 2.817-2.607 3.281l-5.427 3.726-3.312 3.044Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M46.921 36.635c.235 3.24.77 6.563-.534 9.649-.47 1.125-1.228 1.816-3.034 1.444-1.25-.258-2.564-.815-3.718-1.269-1.762-.691-1.506-1.372-1.805-1.97-.118-.238-.31-.506-.577-.806-.694-.784-1.859-1.259-1.902-2.373-.042-1.022.759-1.569 1.165-.867.566.98 1.87 2.642.887-2.539 1.068-.784 1.282-1.094 1.56-1.94.277-.825.576-1.476 1.591-.95 2.105 1.074 3.91 2.116 6.367 1.62Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M46.921 36.635c.022.32.053.63.075.95-3.259.536-4.893-.847-6.966-2.127-.748 1.239-.94 1.6-1.998 2.59.033.362.417 2.353.15 3.334-.214.794-.652.68-1.132.196-.32-.32-1.026-1.785-1.624-.857.203-.63.769-.856 1.1-.299.566.98 1.87 2.642.887-2.538 1.068-.785 1.282-1.094 1.56-1.94.277-.826.577-1.476 1.592-.95 2.093 1.094 3.899 2.136 6.356 1.64Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "m42.744 56.634.887 20.03 3.643 4.438 2.382-5.345-5.544-19.504c.576-1.641.384-2.013.053-2.25-.385-.279-.01-.32-1.293-.165-.844.103-1.698.185-1.58 1.063.095.68.704 1.166 1.452 1.733Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#BB9DF6",
    d: "M38.011 48.936c-.726.237-1.271.474-1.4.918-.437 1.559 2.34 5.934 4.146 6.347.609-1.094 1.132-1.713 2.211-2.436-2.991-.846-4.626-2.26-4.957-4.83Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#BB9DF6",
    d: "M45.062 49.142c.545.021 1.026.186 1.111.29.77.825.802 4.313-.427 6.294-1.047-.99-1.934-1.517-2.863-1.94 2.681-1.538 2.446-3.044 2.18-4.644Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FD2FB",
    d: "M50.885 68.41 36.43 65.715c-.63-.114-1.26.289-1.378.898l-4.327 21.929c-.118.619.3 1.217.93 1.331l14.454 2.693c.63.114 1.26-.288 1.378-.897l4.327-21.93c.117-.608-.3-1.207-.93-1.33Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FD2FB",
    d: "m32.264 80.69-1.25 6.325c2.83.217 5.416.434 8.204 1.094 1.55 1.115 3.547 1.837 8.74 1.166l.79-3.993-4.102.062-12.382-4.654Z",
    opacity: 0.5
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M49.367 84.477c-.299 1.764-.47 2.693-.822 2.951-.887.66-4.349.485-6.165.227-1.602-.227-2.286-2.136-3.44-2.219-.662-1.506.866-3.395 1.731-4.582 2.404.878 6.549-.36 8.568.228 1.229.381.278 2.476.128 3.395Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M49.112 85.86c-.171.887-.332 1.393-.577 1.579-.887.66-4.348.485-6.165.227-1.602-.227-2.286-2.137-3.44-2.22-.662-1.506.075.063.94-1.124 2.618 2.033 5.524 1.517 9.242 1.538Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M33.171 64.137c-2.959 3.674-6.239 6.336-5.534 8.513 1.133 3.51 6.133 5.418 14.23 8.246.375 1.156-.523 3.952-2.179 5.376-6.752-1.733-18.728-3.622-20.993-10.866-.694-2.219-.651-5.346.278-8.514 1.656-5.665 8.066-13.436 13.621-15.582 2.148-.826 2.746 10.123.577 12.827Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#6266D7",
    d: "M39.368 80.019c.801.289 1.635.578 2.5.887.374 1.156-.523 3.953-2.18 5.377-6.751-1.734-18.727-3.622-20.992-10.867 3.9 6.202 17.627 9.546 20.672 4.603Z",
    opacity: 0.35
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M116.375 115.353h34.454c2.296 0 4.166 1.816 4.166 4.025v4.509c0 2.209-1.88 4.025-4.166 4.025h-34.454c-2.287 0-4.167-1.816-4.167-4.025v-4.509c0-2.219 1.88-4.025 4.167-4.025Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "m112.079 58.213-2.649-1.764-3.558 4.953 2.66 1.765 3.547-4.954Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "m110.37 62.63-4.647-3.075-10.576 14.88 4.647 3.076 10.576-14.88Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M119.964 24.778c-10.737 0-19.433 8.4-19.433 18.771s8.696 18.772 19.433 18.772 19.433-8.4 19.433-18.772c0-10.371-8.696-18.771-19.433-18.771Zm0 3.777c8.568 0 15.523 6.718 15.523 14.994s-6.955 14.995-15.523 14.995-15.523-6.719-15.523-14.995 6.955-14.994 15.523-14.994Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M119.964 58.544c8.573 0 15.523-6.714 15.523-14.995 0-8.281-6.95-14.994-15.523-14.994s-15.523 6.713-15.523 14.994c0 8.281 6.95 14.995 15.523 14.995Z",
    opacity: 0.5
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M111.097 31.238c-4.028 2.714-6.656 7.213-6.656 12.311 0 8.276 6.955 14.995 15.523 14.995 4.295 0 8.183-1.682 10.993-4.407-2.51 1.693-5.566 2.683-8.867 2.683-8.568 0-15.523-6.718-15.523-14.994 0-4.128 1.731-7.874 4.53-10.588Z",
    opacity: 0.5
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M120.124 29.834c-4.263 0-8.077 1.817-10.684 4.675a14.463 14.463 0 0 1 9.359-3.405c7.842 0 14.209 6.14 14.209 13.725 0 3.467-1.325 6.625-3.526 9.04 2.97-2.518 4.84-6.202 4.84-10.32.011-7.575-6.346-13.715-14.198-13.715Z",
    opacity: 0.5
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#1182BC",
    d: "m197.995 96.066-2.104-6.46 3.685-5.036 4.402 4.778a394.25 394.25 0 0 1-5.983 6.718Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F2F64",
    d: "M213.486 162.339c-1.902 1.609-2.543 2.28-5 2.373-2.008.083-2.681-.423-3.835-1.31-1.272-.991-1.678-1.61-1.667-2.508.011-1.713.908-3.271 1.004-5.418l4.028.175 1.741-.784c.78.991 2.436 2.807 3.59 4.417.566.784.385 2.208.139 3.055Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#16193B",
    d: "M203.583 157.86c.192-.733.363-1.507.405-2.384l4.028.175 1.742-.784c.309.392.747.908 1.239 1.486-1.581 1.62-6.4 2.529-7.414 1.507Z",
    opacity: 0.5
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F2F64",
    d: "M182.558 154.021c.331 1.579 1.325 2.796 1.485 3.952.267 2.002-.919 4.015-3.376 4.035l-16.057.134c.855-5.294 9.433-2.363 12.318-8.235l3.739.207 1.891-.093Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#16193B",
    d: "M182.558 154.021c.107.516.289.991.481 1.445-1.507 1.011-4.402 1.692-7.767.578a6.427 6.427 0 0 0 1.656-2.116l3.739.206 1.891-.113Z",
    opacity: 0.5
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M171.564 86.406c-.651 3.798-.865 7.42-.812 12.147.203 17.76 3.163 37.873 5.129 55.612 2.617.97 5.501.919 7.681.052.32-10.278.427-20.866.983-31.011.694-12.786 2.361-22.785 5.384-38.74l-12.425-.402-5.94 2.343Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M179.459 86.406c-.651 3.798-.662 14.747-.609 19.474.182 15.84 2.693 32.672 4.712 48.347.32-10.278.427-20.866.983-31.01.609-11.197 1.965-20.258 4.316-33.054l-9.402-3.757Z",
    opacity: 0.5
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M196.136 87.738c.983 2.869 2.276 5.046 3.633 10.918 1.474 6.388 1.891 12.404 2.991 18.617 2.169 12.167 4.872 24.488 8.643 37.666-2.18 1.755-6.442 1.755-8.002 1.218-4.658-10.227-7.511-20.195-11.613-30.567-5.609-14.199-11.741-28.43-16.602-41.928l20.95 4.076Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "m199.042 94.693-.684-7.936c5.93-10.598 5.641-9.35-1.154-19.72.075 7.708-.534 15.386-.074 22.93-8.686 1.796-18.002 2.456-26.399-.31.107-5.005 1.314-12.466 2.553-19.37.844-4.736-.085-9.215.908-13.405.876-3.694 3.002-5.965 6.079-6.821 2.201-.62 4.626-.877 7.083-.785 5.385.207 11.517 1.652 15.363 6.172 4.081 4.798 9.498 15.892 8.846 22.218-.321 3.137-2.404 5.882-12.521 17.027Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#17ACC8",
    d: "M171.597 80.246c.427-2.91.993-6.182 1.549-9.298.844-4.737.053-9.876 1.047-14.066.876-3.694 3.002-5.965 6.079-6.821a19.563 19.563 0 0 1 3.066-.61l.075.094c-1.432 2.012-1.891 2.61-3.793 4.22.363 13.437-.566 15.284-8.023 26.48Z",
    opacity: 0.35
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "m199.042 94.693-.684-7.936c4.316-7.719 5.449-9.236 2.821-13.508 2.916 3.519 1.805 5.614 1.154 9.71-.417 2.643-.866 5.377.448 7.565a342.237 342.237 0 0 1-3.739 4.17Z",
    opacity: 0.4
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M191.019 45.654c.085 1.59.181 2.828.47 4.396-.716 2.415-3.045 4.004-5.374 3.705-1.998-.258-2.521-2.869-1.838-4.489.096-.784.139-1.445.161-2.24l5.053-1.424 1.528.052Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M191.019 45.654c.021.464.054.898.086 1.321-2.158 2.332-5.022 2.704-6.816 2.291a22.55 22.55 0 0 0 .16-2.24l5.053-1.424 1.517.052Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M191.809 43.766c1.293.237 1.624-.186 1.934-1.022.31-.867.289-.63.833-1.29.268-.32.449-.63.567-.95.416-1.062.181-1.702.192-2.528.021-1.01.481-1.403.662-2.053.908-3.179-1.923-5.955-5.01-4.49-1.111-1.94-2.885-1.97-4.498-1.083-1.88-1.104-3.686-.98-4.968.434-2.478 2.745-.16 5.48 1.549 6.212l5.417 3.725 3.322 3.045Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#22043D",
    d: "M191.81 43.766c1.292.237 1.624-.186 1.933-1.022.31-.867.289-.63.834-1.29.267-.32.448-.63.566-.95.417-1.062.181-1.702.192-2.527v-.031c-.801 1.341-2.521 1.6-2.681-.28-.855-.65-1.4-1.454-1.517-2.393-.15-1.187-.673-1.847-2.052-1.476-3.194.877-5.811 2.487-8.621-.082.203 1.558 1.528 2.817 2.607 3.281l5.416 3.726 3.323 3.044Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M182.429 36.635c-.235 3.24-.769 6.563.535 9.649.47 1.125 1.228 1.816 3.034 1.444 1.25-.258 2.564-.815 3.718-1.269 1.762-.691 1.506-1.372 1.805-1.97.118-.238.31-.506.577-.806.694-.784 1.859-1.259 1.902-2.373.042-1.022-.759-1.569-1.165-.867-.566.98-1.87 2.642-.887-2.539-1.068-.784-1.282-1.094-1.559-1.94-.278-.825-.577-1.476-1.592-.95-2.105 1.074-3.91 2.116-6.368 1.62Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M182.429 36.635c-.021.32-.053.63-.075.95 3.259.536 4.893-.847 6.966-2.127.748 1.239.94 1.6 1.998 2.59-.032.362-.417 2.353-.15 3.334.214.794.652.68 1.133.196.32-.32 1.025-1.785 1.624-.857-.203-.63-.77-.856-1.09-.299-.566.98-1.87 2.642-.887-2.538-1.068-.785-1.282-1.094-1.56-1.94-.277-.826-.576-1.476-1.591-.95-2.105 1.094-3.911 2.136-6.368 1.64ZM182.804 45.107c.01.527.053 1.043.042 1.569-.042 2.745-.203 4.025-2.767 5.48-.801.454-1.143.98-1.698 1.764l-1.346.165-2.319-1.166c.395-1.671.363-2.125.022-3.787-.161-.805-.097-1.341.758-2.146l2.041-1.92c.651-.599 1.741-.867 2.628-.62.598.176 1.314.62 1.26 1.466-.042.795-.128 1.125-.523 1.775-.096.29-.139.712-.203 1.321.182-.196.652-1.434.641-1.661-.011-1.094.598-1.868 1.464-2.24Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M181.201 47.14c-.929 1.208-1.624 1.559-2.5 2.364-1.292 1.176-1.292.578-2.5-.61-.042 1.002.364 1.353.759 2.147.331.671-.16 2.105-.385 2.859.716-1.177 1.517-2.291 2.276-3.323.833-1.125 1.517-1.672 2.35-3.437Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M174.706 51.774c1.367.485 2.841.815 3.995 1.682-.352 5.996-.865 10.619-3.034 14.644-2.863 5.314-6.517 7.234-8.247 6.212-1.176-.691-1.614-3.767-.396-8.576 1.186-4.726 4.22-9.535 7.682-13.962Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#20589B",
    d: "m186.607 56.634-.887 20.03-3.643 4.438-2.382-5.345 5.545-19.504c-.577-1.641-.385-2.013-.054-2.25.385-.279.011-.32 1.293-.165.844.103 1.698.185 1.581 1.063-.107.68-.705 1.166-1.453 1.733Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#37BBBC",
    d: "M191.339 48.936c.727.237 1.272.474 1.4.918.438 1.559-2.34 5.934-4.145 6.347-.609-1.094-1.133-1.713-2.212-2.436 2.992-.846 4.626-2.26 4.957-4.83Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#37BBBC",
    d: "M184.288 49.142c-.545.021-1.025.186-1.111.29-.769.825-.801 4.313.428 6.294 1.046-.99 1.933-1.517 2.863-1.94-2.682-1.538-2.447-3.044-2.18-4.644Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 111.946,
    x2: 111.198,
    y1: 159.498,
    y2: 169.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 111.77,
    x2: 111.511,
    y1: 161.065,
    y2: 166.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 144.091,
    x2: 143.668,
    y1: 155.048,
    y2: 160.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 120.362,
    x2: 148.068,
    y1: 145.22,
    y2: 10.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 95.012,
    x2: 108.267,
    y1: 35.742,
    y2: 2.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 75.183,
    x2: 75.628,
    y1: 5.249,
    y2: 7.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FF8ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBBA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 79.997,
    x2: 96.915,
    y1: 17.648,
    y2: 24.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FF8ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBBA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 85.61,
    x2: 87.174,
    y1: 15.073,
    y2: 28.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FF8ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBBA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 143.36,
    x2: 155.956,
    y1: 27.118,
    y2: -0.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 147.476,
    x2: 141.23,
    y1: 26.297,
    y2: 1.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 105.995,
    x2: 131.055,
    y1: 106.985,
    y2: 76.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 107.355,
    x2: 109.026,
    y1: 107.873,
    y2: 84.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 73.42,
    x2: 76.86,
    y1: 105.196,
    y2: 113.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C8EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CFDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 93.879,
    x2: 113.303,
    y1: 156.571,
    y2: 128.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 95.074,
    x2: 97.32,
    y1: 131.479,
    y2: 126.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 95.584,
    x2: 96.404,
    y1: 145.853,
    y2: 131.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 96.201,
    x2: 96.24,
    y1: 147.544,
    y2: 150.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD24C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBD2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 83.632,
    x2: 85.334,
    y1: 48.857,
    y2: 52.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 60.856,
    x2: 68.007,
    y1: 50.442,
    y2: 69.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A77EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E65D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 23.116,
    x2: 21.379,
    y1: 158.64,
    y2: 154.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 50.444,
    x2: 48.608,
    y1: 156.172,
    y2: 152.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 54.497,
    x2: 39.892,
    y1: 99.261,
    y2: 138.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40457F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E2353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 48.474,
    x2: 18.847,
    y1: 96.284,
    y2: 139.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40457F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E2353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 39.637,
    x2: 46.566,
    y1: 57.338,
    y2: 88.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A77EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E65D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 41.711,
    x2: 41.221,
    y1: 47.933,
    y2: 49.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 40.831,
    x2: 41.252,
    y1: 31.674,
    y2: 36.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A2D68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22043D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 42.548,
    x2: 40.493,
    y1: 38.998,
    y2: 45.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 39.842,
    x2: 48.019,
    y1: 57.06,
    y2: 74.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40457F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E2353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 45.189,
    x2: 43.548,
    y1: 82.343,
    y2: 86.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 43.106,
    x2: 44.269,
    y1: 87.031,
    y2: 84.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 36.654,
    x2: 26.929,
    y1: 66.914,
    y2: 78.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A77EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E65D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 133.408,
    x2: 133.795,
    y1: 125.832,
    y2: 117.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C8EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CFDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 110.212,
    x2: 108.12,
    y1: 57.801,
    y2: 61.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A77EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E65D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 106.52,
    x2: 100.163,
    y1: 62.241,
    y2: 73.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A77EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E65D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 115.692,
    x2: 122.58,
    y1: 27.631,
    y2: 55.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A77EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E65D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 113.329,
    x2: 118.421,
    y1: 32.394,
    y2: 54.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A77EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E65D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 174.851,
    x2: 189.456,
    y1: 99.261,
    y2: 138.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#235DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123A76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 181.374,
    x2: 189.411,
    y1: 100.113,
    y2: 139.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#235DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123A76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 180.874,
    x2: 210.502,
    y1: 96.284,
    y2: 139.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#235DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123A76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 184.674,
    x2: 193.317,
    y1: 64.292,
    y2: 88.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94E69A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 201.653,
    x2: 200.279,
    y1: 76.35,
    y2: 93.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A77EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E65D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 187.646,
    x2: 187.86,
    y1: 47.431,
    y2: 48.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 188.536,
    x2: 188.105,
    y1: 31.726,
    y2: 36.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A2D68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22043D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 186.801,
    x2: 188.856,
    y1: 38.998,
    y2: 45.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 178.528,
    x2: 179.226,
    y1: 49.923,
    y2: 51.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 172.292,
    x2: 172.775,
    y1: 51.738,
    y2: 77.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94E69A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADC9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQa);
export default __webpack_public_path__ + "static/media/QA.56447d5d86201e9ad6cff139a94b722a.svg";
export { ForwardRef as ReactComponent };